import React, { memo } from "react";
import { Text } from "react-native";
import { fonts } from "@constants/metrics";
import color from "@constants/color";
import { fontFamily } from "@utils/styles";

function AppText(props) {
  const { disabled = false } = props || {};
  const styles =
    props.style && Array.isArray(props.style)
      ? props.style
      : (props.style && { ...props.style }) || {};

  let selectedFontFamily = fontFamily.regular;

  if (props.bold) {
    selectedFontFamily = fontFamily.bold;
  } else if (props.semiBold) {
    selectedFontFamily = fontFamily.semiBold;
  }

  return (
    <Text
      {...props}
      style={[
        {
          fontSize: fonts[props.fontType],
          fontFamily: selectedFontFamily,
          textAlign: props.center ? "center" : "auto",
        },
        styles,
        [disabled ? { color: color.lightMediumBlack } : {}],
      ]}
      allowFontScaling={false}
    />
  );
}

export default memo(AppText);
